import React, { useRef, useCallback, useEffect } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import styles from "./ChunksModal.module.css";

interface ChunksModalProps {
    isOpen: boolean;
    onClose: () => void;
    fileName: string;
    snippet: string | undefined;
    description: string | undefined;
    title: string | undefined;
    author: string | undefined;
}

const ChunksModal: React.FC<ChunksModalProps> = ({
    isOpen,
    onClose,
    fileName,
    snippet,
    description,
    title,
    author,
}) => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;
    const modalContentRef = useRef<HTMLDivElement>(null);

    const handleOutsideClick = useCallback(
        (e: MouseEvent) => {
            if (modalContentRef.current && !modalContentRef.current.contains(e.target as Node)) {
                onClose();
            }
        },
        [onClose],
    );

    useEffect(() => {
        if (isOpen) {
            document.addEventListener("mousedown", handleOutsideClick);
        }
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [isOpen, handleOutsideClick]);

    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className="database-modal-overlay">
            <div className={`database-modal-content ${styles.modal}`} ref={modalContentRef}>
                <div className="database-modal-header">
                    <h2>{t("matchedTextInVectorSearch") || "Matched Text in Vector Search"}</h2>
                    <button className="database-modal-close-button" onClick={onClose}>
                        ×
                    </button>
                </div>

                <div className="database-modal-body">
                    <div className={styles.fileName}>
                        <strong>{t("file") || "File"}:</strong> {fileName}
                    </div>

                    {snippet ? (
                        <div className={styles.snippet}>
                            {title ? (
                                <>
                                    {title}
                                    <br />
                                    <br />
                                </>
                            ) : (
                                ""
                            )}
                            {author ? (
                                <>
                                    {author}
                                    <br />
                                    <br />
                                </>
                            ) : (
                                ""
                            )}
                            {description ? (
                                <>
                                    {description}
                                    <br />
                                    <br />
                                </>
                            ) : (
                                ""
                            )}
                            {snippet}
                        </div>
                    ) : (
                        <p className={styles.noChunks}>
                            {t("noSnippetAvailable") || "No content preview available for this file"}
                        </p>
                    )}
                </div>
            </div>
        </div>,
        document.body,
    );
};

export default ChunksModal;
